module.exports = __webpack_public_path__ + "static/media/metricas.1445317d.svg";